/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_History_Load_Failed1Inputs */

const vi_cmstools_history_load_failed1 = /** @type {(inputs: Cmstools_History_Load_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được lịch sử. Tải lại trang để thử lại.`)
};

/**

* @param {Cmstools_History_Load_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_history_load_failed1 = /** @type {((inputs?: Cmstools_History_Load_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_History_Load_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_history_load_failed1(inputs)
});
export { cmstools_history_load_failed1 as "cmsTools_history_load_failed" }